import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { setCookie, getCookie } from '../Util/CommonUtils';
import HomePage from '../Home/HomePage';
import HostedSignIn from '../Header/HostedSignIn';

const WelcomeBackSignIn = (props) => {
  const [showWelcomeSignInModal, setShowWelcomeSignInModal] = useState(false);
  const [showSignInModal, setSignInModal] = useState(false);
  const timedOutModal = getCookie('IMSessionTimedOutModal');

  const closeSignInModal = () => {
    setShowWelcomeSignInModal(false);
  };

  const openWelcomeSignInModal = (flag) => {
    setShowWelcomeSignInModal(flag);
    setCookie('IMSessionTimedOutModal', false);
  };

  useEffect(() => {
    if (timedOutModal === 'true') {
      openWelcomeSignInModal(true);
    } else {
      setSignInModal(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container-center-lg sign-in-container">
      <HomePage {...props} signInModal={showSignInModal} />
      {showWelcomeSignInModal && (
        <HostedSignIn
          {...props}
          showModal={showWelcomeSignInModal}
          closeModal={closeSignInModal}
          location="orderhistory"
          WelcomeBackSignIn
        />
      )}
    </div>
  );
};

WelcomeBackSignIn.propTypes = {
  closeSignInModal: PropTypes.func,
  openSignInModal: PropTypes.func,
};

export default WelcomeBackSignIn;
